export const isValidMessageUrl = (content) =>
  /^(https?:\/\/)([\w.-]+\.[a-z]{2,}(\/.*)?)$/.test(content || "");

export const formatPhoneNumber = (phoneNumber) => {
  const cleaned = `${phoneNumber || ""}`.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
  }

  return phoneNumber;
};

export const getChatAvatarSrc = (item) => {
  if (item?.type === "customer_support") {
    return "/assets/images/tb.svg";
  }

  if (item?.type === "job_customer_technician" && item?.image !== null) {
    return item?.image;
  }

  return "/assets/images/avatar-placeholder.png";
};

export const getNewChatAvatarSrc = (item) =>
  item?.technician_profile_image !== null
    ? item?.technician_profile_image
    : "/assets/images/avatar-placeholder.png";

export const getConversationAvatarSrc = (userData) => {
  if (userData?.type === "customer_support") {
    return "/assets/images/tb.svg";
  }

  if (
    userData?.type === "job_customer_technician" &&
    userData?.image !== null
  ) {
    return userData?.image;
  }

  if (
    userData?.type === "job_customer_technician" &&
    userData?.technician_profile_image !== null
  ) {
    return userData?.technician_profile_image;
  }

  return "/assets/images/avatar-placeholder.png";
};

export const getLastMessagePreview = (item) => {
  if (item?.last_message === null) {
    return "No messages yet!";
  }

  if (item?.last_message?.content !== null) {
    if (item?.last_message?.content?.length >= 25) {
      return `${item?.last_message?.content.substring(0, 25)}...`;
    }

    if (item?.last_message?.content === "null") {
      return item?.last_message?.files?.[0]?.type;
    }

    return item?.last_message?.content;
  }

  if (item?.last_message?.files?.length > 0) {
    return item?.last_message?.files?.[0]?.type;
  }

  if (item?.new_message?.files?.[0]?.type) {
    return item?.new_message?.files?.[0]?.type;
  }

  return "";
};
